import { GeneralFieldController } from "./general-field-controller";

export class FormChatFieldController extends GeneralFieldController {}
